import { inject, Injectable, signal } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { FILTER_PATTERNS } from '@shared/constants';

@Injectable()
export class LoginFormService {
  private readonly _fb = inject(NonNullableFormBuilder);

  private readonly _isLoading = signal(false);

  public readonly isLoading = this._isLoading.asReadonly();

  public setIsLoading(value: boolean) {
    this._isLoading.set(value);
  }

  public form = this._fb.group({
    username: [
      '',
      [Validators.required, Validators.pattern(FILTER_PATTERNS.email)],
    ],
    password: ['', [Validators.required, Validators.minLength(8)]],
  });
}
